
import { Component, Vue } from 'vue-property-decorator'
import ticketNetwork from '@/views/Ticket/indexNetwork.vue'

@Component({
  name: 'AllOrderLists',
  components: {
    ticketNetwork
  }
})
export default class extends Vue {
}
